export const galleryData = [
  {
    id: 1,
    title: "Spiritual Gathering & Vedic Chants",
    category: "Events",
    image:
      "https://images.unsplash.com/photo-1545128485-c400e7702796?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: 2,
    title: "Morning Meditation Sanctuary",
    category: "Gau Seva",
    image:
      "https://images.unsplash.com/photo-1506126613408-eca07ce68773?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: 3,
    title: "Sacred Ashram Architecture",
    category: "Ashram",
    image:
      "https://images.unsplash.com/photo-1518241353330-0f7941c2d9b5?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: 4,
    title: "Community Feast & Sewa Days",
    category: "Events",
    image:
      "https://images.unsplash.com/photo-1464692805480-a69dfaafdb0d?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: 5,
    title: "Peaceful Evening Aarti",
    category: "Spiritual",
    image:
      "https://images.unsplash.com/photo-1519817650390-64a93db51149?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: 6,
    title: "Nature & Soul Alignment Hub",
    category: "Ashram",
    image:
      "https://images.unsplash.com/photo-1447752875215-b2761acb3c5d?q=80&w=800&auto=format&fit=crop",
  },
];
